// @see http://stackoverflow.com/a/2450976/362769
function shuffle(array) {
  var currentIndex = array.length, temporaryValue, randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {

    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
}

!function($) {

  // Add custom JavasScript here
  // --------------------------



  // Document ready
  $(function() {

  	function storageAvailable(type) {
    try {
      var storage = window[type],
        x = '__storage_test__';
      storage.setItem(x, x);
      storage.removeItem(x);
      return true;
    }
    catch(e) {
      return false;
    }
  }

  if( storageAvailable('sessionStorage') ) {

    if( $('#js-customization-text').length > 0 ){

      (function(){
        var customizations = sessionStorage.getItem('customizations');
        if( ! customizations )
          return;
        customizations = JSON.parse(customizations);
        if( typeof customizations[ productName ] === 'undefined' )
          return;
        $('#js-customization-text').val( customizations[productName] );

      })();


      $('#js-customization-text').on('keyup',function(e){
        var v = $(this).val();
        var customizations = sessionStorage.getItem('customizations');
        if( ! customizations )
          customizations = {};
        else
          customizations = JSON.parse(customizations);
        customizations[ productName ] = v;
        sessionStorage.setItem('customizations', JSON.stringify(customizations) );
      });
    }

    if( $('#cart-note').length > 0 ){
      var customizations = sessionStorage.getItem('customizations');
      if( ! customizations )
        return;
      customizations = JSON.parse( customizations );
      var $n = $('#cart-note');
      var existingNote = $n.val();
      var newtext = '';

      for( key in customizations ){
        if(!customizations.hasOwnProperty(key))
          continue;
        if( customizations[key] == '' )
          continue;
        
        var thisNotetoAdd = 'Customization for '+key+': '+customizations[key];
        if( existingNote.indexOf(thisNotetoAdd) == -1)
          newtext += thisNotetoAdd + '\n-----\n';
      }
      newtext += existingNote;
      $n.val(newtext);
    }
  }

  });

  /**
   * This manages the behavior of the top search bar. Mostly to play nice with
   * our search plugin
   */
  (function(){
    var searchBtn = document.querySelector('a[data-toggle-top-bar-search]');
    if( ! searchBtn )
      return;
    var s = document.getElementById('top-bar-search').querySelector('input[type="search"]');
    searchBtn.addEventListener('click', function(e){
      if( s === document.activeElement ){

      } else {
        e.preventDefault();
        s.focus();
      }
    });
    s.addEventListener('blur', function(e){
      var me = this;
      window.setTimeout( function(){
        me.value = '';
      }, 2000 );
    });
  })();

  /**
   * Hide tags which start with __ from Omega Search sidebar filters
   */
  
  (function(){

    var removeTagsFromFilters = function(){
      var filters = document.querySelector('.os-e.os-filters');
      if( ! filters )
        return;
      var filterBlocks = filters.querySelectorAll('.os-filter');
      var title;
      for(var i=0;i<filterBlocks.length;i++){
        title = filterBlocks[i].querySelector('.os-title').innerText.trim().toLowerCase();
        if( title !== 'tags' )
          continue;
        var tagEls = filterBlocks[i].querySelectorAll('.os-filter-bucket');
        for(var x=0;x<tagEls.length;x++){
          var tag = tagEls[x].querySelector('.bucket').innerText;
          // console.log( tag.indexOf('__') );
          if( tag.indexOf('__') !== 0 )
            continue;
          console.log(tagEls[x]);
          // $(tagEls[x]).hide();
          tagEls[x].classList.add('hide-it-omg');
        }
      }
    };

    // hook into the ajax request (not fetch()) getting the search results from
    // the plugin's server
    (function(open){
      XMLHttpRequest.prototype.open = function(){
        this.addEventListener('load', function(){
          var url = this.responseURL;
          if( url.indexOf('search-geo.omegacommerce.com') < 0
            && url.indexOf('result?ID=') < 0 )
            return;

          window.setTimeout( removeTagsFromFilters, 250 );
        });
        open.apply(this, arguments);
      };
    })(XMLHttpRequest.prototype.open);

    
  })();

}(jQuery);
